import React, {useEffect, useState, useCallback} from 'react';
import DataTablesEmployee from './DataTablesEmployee';
import DataTablesEmployeeAdmin from './DataTablesEmployeeAdmin';
import DataTablesTransaction from './DataTablesTransaction';
import {
    ListEmployee,
    createemployee, editemployee, listhome,
    deleteemployee,
    uploadexele,
    gettransaction,
    addcredit, ListCompanyLittle, getprovince, getcity
} from "../../../../api/api";
import AuthUserDropdown from "../../../shared/widgets/AuthUserDropdown";
import {useDropzone} from "react-dropzone";
import {Checkbox, Grid, ListItem, Typography} from "@mui/material";
import Button from '@mui/material/Button';
import Add from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {makeStyles} from '@mui/styles';
import {useNavigate} from "react-router-dom";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import {
    Dialog,
    DialogActions,
    TextField,
    DialogContent,
    DialogContentText,
    DialogTitle,
    InputLabel, CircularProgress,
    Select,
    Switch, IconButton
} from "@mui/material";
import Swal from "sweetalert2";
import DndWrapper from "../../extensions/dropzone/components/DndWrapper";
import List from "@mui/material/List";
import JumboDemoCard from "@jumbo/components/JumboDemoCard";
import code from "../../extensions/dropzone/components/demo-code/dz-basic.txt";
import Div from "@jumbo/shared/Div";
import CurrencyCalculator from "../../../shared/widgets/CurrencyCalculator";
import GeneralInfo from "../../../shared/metrics/WelcomSummary/components/GeneralInfo";
import SiteAudienceInfo from "../../../shared/metrics/WelcomSummary/components/SiteAudienceInfo";
import SiteVisitsGraph from "../../../shared/metrics/WelcomSummary/components/SiteVisitsGraph";
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import clsx from "clsx";
import DialogClose from './DialogClose';
import {Pagination, Stack} from "@mui/material";
import PaginationItem from '@mui/material/PaginationItem';

import {
    savecredit,
    savereviewadmin,
    savetypeadmin,
    savereview,
    savecatid,
    savepagenumber,
    savecity,
    savecountmatch,
    saveprovince,
    saveQ,
    savestatus
} from '../../../redux/actions/contactsApp'
import {useDispatch, useSelector} from 'react-redux'
import sampleexel from '../../../../assets/sample.xlsx';
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {userPhotos} from "../../../shared/widgets/UserPhotos/data";
import PictureItem from "../../../shared/widgets/UserPhotos/PictureItem";
import FormHelperText from "@mui/material/FormHelperText";


import "react-image-gallery/styles/css/image-gallery.css";
import Card from "@mui/material/Card";
import ImageGallery from "react-image-gallery";

const images = [
    {
        original: "https://picsum.photos/id/1018/1000/600/",
        thumbnail: "https://picsum.photos/id/1018/250/150/",
    },
    {
        original: "https://picsum.photos/id/1015/1000/600/",
        thumbnail: "https://picsum.photos/id/1015/250/150/",
    },
    {
        original: "https://picsum.photos/id/1019/1000/600/",
        thumbnail: "https://picsum.photos/id/1019/250/150/",
    },
];

let pagesize = 30;
let pagenumber0 = 1;
let typestatus = 0;
let q = "";

let pagesizet = 30;
let pagenumbert = 1;
let qt = "";


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

function toPersianNum(num, dontTrim) {

    if (num === '') {
        return '';
    }

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
};

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    chip: {
        margin: theme.spacing(1),
    },

    input: {
        fontFamily: 'iransans',
        width: '100%',
        height: 50,
        marginTop: 15
    },

    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 10,
        fontSize: 5,
        height: 50,
        paddingLeft: 10,
        paddingRight: 10,
        marginBottom: 0,
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        color: 'rgba(0, 0, 0, 0.54)',


    },


    bordererror: {
        fontFamily: 'iransans',
        border: '1px solid red',
        borderRadius: 10,
        fontSize: 5,
        height: 50,
        paddingLeft: 10,
        paddingRight: 10,
        marginBottom: 0,
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        color: 'rgba(0, 0, 0, 0.54)',


    },


    inputremove: {

        textAlign: 'right',


        '&:focus': {
            backgroundColor: 'transparent',
            outline: 'none'
        },


    },

    inputremovecenter: {

        textAlign: 'center',
        border: 0,
        outline: 0,
        boxShadow: 'none',
        borderRadius: 0,
        borderBottom: '5px solid #ccc',

        '&:focus': {
            backgroundColor: 'transparent',
            outline: 'none',
            borderColor: '#152e84 !important'
        },


    },

    oncepassword: {


        "&:hover": {
            cursor: 'pointer'
        },

    },

    buttonProgress: {
        color: '#dadada',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    error: {

        marginTop: 5,
        color: 'red',
        fontSize: 10,
        fontFamily: 'iransans'


    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },


}));


function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            style={{padding: 0}}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)}/>}
            icon={<span className={classes.icon}/>}
            {...props}
        />
    );
}


const DataTables = () => {

        // const classes = useStyles();
        // const {acceptedFiles, getRootProps, getInputProps} = useDropzone();


        //  const {getRootProps: getRootProps, getInputProps: getInputProps} = useDropzone({
        //     accept: 'xlsx/*',
        //     multiple: false,
        //     onDrop: acceptedFiles => {
        //         // console.log(acceptedFiles.File);
        //         var x = acceptedFiles.map(file => Object.assign(file, {
        //             preview: URL.createObjectURL(file)
        //
        //         }))
        //         debugger;
        //         files.length = 0;
        //
        //
        //         for (let i = 0; i < files.length; i++) {
        //             x.push(files[i]);
        //         }
        //         // url = x[0];
        //         setFiles(x);
        //
        //     }
        // });

        const {
            admin,
            review,
            reviewadmin,
            typeadmin,
            countmatch,
            q,
            status,
            province,
            city,
            catid,
            pagenumber
        } = useSelector(({contactsApp}) => contactsApp);
        const [EmployeeList, setEmployeeList] = React.useState([]);
        const [CompanyList, setCompanyList] = React.useState([]);
        const [Loadercompany, setLoaderCompany] = React.useState(false);
        const [TranactionList, setTranactionList] = React.useState([]);
        const [files, setFiles] = React.useState([]);
        const [Loader, setLoader] = React.useState(true);
        const [Loader2, setLoader2] = React.useState(false);
        const [openadd, setOpenadd] = React.useState(false);
        const [openedit, setOpenedit] = React.useState(false);
        const [openexel, setOpenexel] = React.useState(false);
        const [opentransaction, setOpentransaction] = React.useState(false);
        const [loaderbutton, setLoaderButton] = React.useState(false);
        const [loaderdelete, setLoaderdelete] = React.useState(false);
        const [loaderadd, setLoaderadd] = React.useState(false);
        const [loadersend, setLoadersend] = React.useState(false);
        const [opendelete, setOpendelete] = React.useState(false);
        const [loaderdeletedialog, setLoaderdeletedialog] = React.useState(false);
        const [name, setName] = React.useState('');
        const [id, setId] = React.useState('');
        const [family, setFamily] = React.useState('');
        const [nationalid, setNationalid] = React.useState('');
        const [mobile, setMobile] = React.useState('');
        const [personnelcode, setPersonnelcode] = React.useState('');
        const [credit, setCredit] = React.useState('');
        const [credit2, setCredit2] = React.useState('');
        const [credituser, setCredituser] = React.useState('');
        const [creditadd, setCreditadd] = React.useState('');
        const [creditadd2, setCreditadd2] = React.useState('');
        const [typeadd, setTypeadd] = React.useState(1);
        const [countresponse, setCountresponse] = React.useState(0);
        const [count, setCount] = React.useState(0);
        const [isadmin, setIsadmin] = React.useState(false);
        // const [status, setStatus] = React.useState(0);
        const [cityvalue, setCityvalue] = React.useState(city);
        const [provincevalue, setProvincevalue] = React.useState(province);
        const [statusvalue, setStatusvalue] = React.useState(status);
        const [companyid, setCompanyid] = React.useState(0);
        const [catidvalue, setCatidvalue] = React.useState(catid);
        const [matchvalue, setMatchvalue] = React.useState(countmatch);
        const [reviewvalue, setReviewvalue] = React.useState(review);
        const [reviewadminvalue, setReviewadminvalue] = React.useState(reviewadmin);
        const [typeadminvalue, setTypeadminvalue] = React.useState(typeadmin);
        const [pagenumbermain, setPagenumberMain] = React.useState(pagenumber);
        const [companyidnew, setCompanyidnew] = React.useState(0);
        const [countresponset, setCountresponset] = React.useState(0);
        const [textbutton, setTextbutton] = React.useState('');
        const [description, setDescription] = useState('');
        const [expireddate, setExpireddate] = React.useState('');
        const [amountpos, setAmountpos] = React.useState('');
        const [amountneg, setAmountneg] = React.useState('');
        const [defaultValue, setDefaultValue] = React.useState('');
        const [valueq, setValueq] = React.useState(q);
        const [value, setValue] = React.useState('افزایش اعتبار');
        const dispatch = useDispatch();
        const [switchhpossibility, setSwitchhpossibility] = React.useState(false);
        const [errorname, setErrorname] = useState(false);
        const [helpername, setHelpername] = useState('');
        const [errorfamily, setErrorfamily] = useState(false);
        const [helperfamily, setHelperfamily] = useState('');
        const [errormelli, setErrormelli] = useState(false);
        const [helpermelli, setHelpermelli] = useState('');
        const [errornumber, setErrornumber] = useState(false);
        const [helpernumber, setHelpernumber] = useState('');
        const [errorcode, setErrorcode] = useState(false);
        const [helpercode, setHelpercode] = useState('');
        const [errorcredit, setErrorcredit] = useState(false);
        const [helpercredit, setHelpercredit] = useState('');
        const [adminshow, setAdminshow] = useState(false);
        const [age, setAge] = React.useState(0);
        const [imp, setImp] = useState(false);
        const [helperimp, setHelperimp] = useState('');
        const [provincelist, setProvincelist] = useState([]);
        const [citylist, setCitylist] = useState([]);
        const navigate = useNavigate();

        const handleChangeswitchpossibility = (event) => {
            // alert(event.target.checked);
            setSwitchhpossibility(event.target.checked);
        };


        const handleChange = (event) => {
            debugger;

            setValue(event.target.value);

            if (event.target.value === 'افزایش اعتبار') {

                setTypeadd(1);
            } else {
                setTypeadd(2);
            }


        };

        const {getRootProps, getInputProps} = useDropzone({

            onDrop: acceptedFiles => {
                setFiles(
                    acceptedFiles.map(file =>
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                        }),
                    ),
                );

            },
        });

        const onDescription = (e) => {
            setDescription(e.target.value);
        };

        //  React.useEffect(
        //     () => () => {
        //         files.forEach(file => URL.revokeObjectURL(file.preview));
        //     },
        //     [files],
        // );


        // const onDrop = useCallback(acceptedFiles => {
        //
        //     console.log(acceptedFiles);
        //     // setFiles(acceptedFiles.map(file => Object.assign(file, {
        //     //     preview: URL.createObjectURL(file)
        //     // })));
        //     setFiles(acceptedFiles[0])
        //
        //     // filee=acceptedFiles[0];
        //     // setFiles(acceptedFiles[0]);
        // }, []);

        // const onDrop = useCallback(acceptedFiles => {
        //     setFiles(acceptedFiles.map(file => Object.assign(file, {
        //         preview: URL.createObjectURL(file)
        //     })));
        // }, []);
        //
        // const {
        //     getRootProps,
        //     getInputProps
        // } = useDropzone({
        //     onDrop
        // });

        // useEffect(() => () => {
        //     files.forEach(file => URL.revokeObjectURL(file.preview));
        // }, [files]);

// useEffect(() => () => {
//     // files.forEach(file => URL.revokeObjectURL(file.preview));
//     <ListItem selected key={files[0].path} sx={{width: 'auto', mr: 1}}>
//             {files[0].path} - {files[0].size} bytes
//         </ListItem>
//
// }, [files]);

        const onContactClose = () => {

            setOpenadd(false);

        };

        const onContactCloseEdit = () => {

            setOpenedit(false);

        };

        const onContactCloseExel = () => {

            setOpenexel(false);

        };

        const onContactCloseTransaction = () => {

            setOpentransaction(false);

        };

        useEffect(() => {

            setAdminshow(admin);

            if (admin) {
                ListCompanyLittle()
                    .then((response) => {
                        let cl = []
                        cl.push({id: 0, name: "همه"})
                        cl.push(...response.data.list)
                        setCompanyList(cl)

                        setLoaderCompany(true);

                    })
                    .catch((error) => {


                    });
            } else {

            }

        }, [admin]);


        function numberWithCommas(nStr) {


            if (typeof nStr == "number") nStr = nStr.toString();
            nStr = nStr.replace(/\,/g, "");
            let x = nStr.split('.');
            let x1 = x[0];
            let x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;


            // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        // useEffect(() => {
        //
        //     setCredit2(numberWithCommas(credit));
        //
        // }, [credit]);


        useEffect(() => {

            setCreditadd2(numberWithCommas(creditadd));

        }, [creditadd]);

        useEffect(() => {

            // var bodyFormData = new FormData();
            // bodyFormData.append('Guest', false);
            // alert(reviewadmin);
            // alert(typeadmin);

            listhome(pagenumbermain, provincevalue, cityvalue, catidvalue, q, statusvalue, matchvalue,reviewvalue, reviewadminvalue,typeadminvalue)
                .then((response) => {

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);
                    setIsadmin(response.data.IsAdmin);

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );


                    setEmployeeList(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });

            getprovince()
                .then((response) => {

                    setProvincelist(response.data.result);

                })
                .catch((error) => {
                });

            getcity(8)
                .then((response) => {

                    setCitylist(response.data.result)

                })
                .catch((error) => {
                });


        }, []);


        const onRefreshpage = () => {

            // listhome(pagenumber, provincevalue,cityvalue,catidvalue,q,statusvalue)
            //     .then((response) => {
            //         setEmployeeList(response.data.list)
            //         setLoader(false);
            //     })
            //     .catch((error) => {
            //
            //
            //     });


        }


        const onRefreshtransaction = () => {

            ListEmployee()
                .then((response) => {
                    setEmployeeList(response.data.list)
                    setLoader(false);
                })
                .catch((error) => {


                });


        }


        const opennewemployee = () => {
            setName('');
            setFamily('');
            setNationalid('');
            setMobile('');
            setPersonnelcode('');
            setCredit('');
            setExpireddate('');

            setErrorname(false);
            setHelpername('')
            setErrorfamily(false);
            setHelperfamily('')
            setErrormelli(false);
            setHelpermelli('')
            setErrornumber(false);
            setHelpernumber('')
            setErrorcode(false);
            setHelpercode('')
            setErrorcredit(false);
            setHelpercredit('')


            setOpenadd(true);
        }

        const onaddcredit = () => {


            if (creditadd === '') {
                Toast.fire({
                    icon: 'error',
                    title: 'لطفا اعتبار را وارد کنید'
                })
                return;
            }


            setLoaderadd(true)
            var bodyFormData2 = new FormData();
            bodyFormData2.append('Id', id);
            bodyFormData2.append('Credit', creditadd);
            bodyFormData2.append('Type', typeadd);
            bodyFormData2.append('Description', description);
            // alert(id)
            // bodyFormData2.append('Id', response.data.Id);
            // bodyFormData2.append('File', files[i]);

            addcredit(bodyFormData2)
                .then((response) => {
                    setLoaderadd(false)
                    Toast.fire({
                        icon: 'success',
                        title: response.data.errorDescription
                    })
                    setDescription('');
                    setCreditadd('');
                    ongettransaction(id)
                    onRefreshpage()


                })
                .catch((error) => {
                    setLoaderadd(false)
                    setOpenedit(false);
                });


        }


        const onopenexel = () => {

            setOpenexel(true);
            setFiles([]);


        }


        const onsaveemployee = () => {

            let error = false;

            if (name === '') {
                setErrorname(true);
                setHelpername('لطفا نام را  وارد کنید')
                error = true;
            }
            if (family === '') {
                setErrorfamily(true);
                setHelperfamily('لطفا نام خانوادگی را  وارد کنید')
                error = true;
            }
            if (mobile === '') {
                setErrornumber(true);
                setHelpernumber('لطفا شماره همراه را  وارد کنید')
                error = true;
            }
            if (nationalid === '') {
                setErrormelli(true);
                setHelpermelli('لطفا کدملی را  وارد کنید')
                error = true;
            }
            // if (personnelcode === '') {
            //     setErrorcode(true)
            //     setHelpercode('لطفا کد پرسنلی را  وارد کنید')
            //     error = true;
            // }
            if (credit === '') {
                setErrorcredit(true)
                setHelpercredit('لطفا اعتبار را  وارد کنید')
                error = true;
            }
            if (error) {
                return;
            }


            setLoaderButton(true)
            var bodyFormData2 = new FormData();
            bodyFormData2.append('name', name);
            bodyFormData2.append('family', family);
            bodyFormData2.append('nationalid', nationalid);
            bodyFormData2.append('mobile', mobile);
            bodyFormData2.append('personnelcode', personnelcode);
            bodyFormData2.append('credit', credit);
            bodyFormData2.append('expireddate', expireddate);
            bodyFormData2.append('companyid', companyid);
            // bodyFormData2.append('Id', response.data.Id);
            // bodyFormData2.append('File', files[i]);

            createemployee(bodyFormData2)
                .then((response) => {
                    if (response !== undefined) {
                        setLoaderButton(false)
                        setOpenadd(false);
                        setOpenedit(false);
                        Toast.fire({
                            icon: 'success',
                            title: response.data.errorDescription
                        })
                        onRefreshpage();
                    } else {
                        setLoaderButton(false)
                    }


                })
                .catch((error) => {
                    setLoaderButton(false)

                });


        }


        const oneditemployee = () => {

            let error = false;

            if (name === '') {
                setErrorname(true);
                setHelpername('لطفا نام را  وارد کنید')
                error = true;
            }
            if (family === '') {
                setErrorfamily(true);
                setHelperfamily('لطفا نام خانوادگی را  وارد کنید')
                error = true;
            }
            if (mobile === '') {
                setErrornumber(true);
                setHelpernumber('لطفا شماره همراه را  وارد کنید')
                error = true;
            }
            if (nationalid === '') {
                setErrormelli(true);
                setHelpermelli('لطفا کدملی را  وارد کنید')
                error = true;
            }
            // if (personnelcode === '') {
            //     setErrorcode(true)
            //     setHelpercode('لطفا کد پرسنلی را  وارد کنید')
            //     error = true;
            // }
            if (credit === '') {
                setErrorcredit(true)
                setHelpercredit('لطفا اعتبار را  وارد کنید')
                error = true;
            }

            if (error) {
                return;
            }


            setLoaderButton(true)
            var bodyFormData2 = new FormData();
            bodyFormData2.append('id', id);
            bodyFormData2.append('name', name);
            bodyFormData2.append('family', family);
            bodyFormData2.append('nationalid', nationalid);
            bodyFormData2.append('mobile', mobile);
            bodyFormData2.append('personnelcode', personnelcode);
            bodyFormData2.append('credit', credit);
            bodyFormData2.append('active', switchhpossibility);
            bodyFormData2.append('expireddate', expireddate);
            bodyFormData2.append('companyid', companyid);
            // bodyFormData2.append('Id', response.data.Id);
            // bodyFormData2.append('File', files[i]);

            editemployee(bodyFormData2)
                .then((response) => {
                    if (response !== undefined) {
                        setLoaderButton(false)
                        setOpenedit(false);
                        Toast.fire({
                            icon: 'success',
                            title: response.data.errorDescription
                        })
                        onRefreshpage();

                    } else {
                        setLoaderButton(false)
                    }


                })
                .catch((error) => {
                    debugger;
                    setLoaderButton(false)

                });


        }

        const onselectcity = (id) => {

            getcity(id)
                .then((response) => {

                    setCitylist(response.data.result)

                })
                .catch((error) => {
                });


        }


        const ondeleteemployee = () => {

            // alert('sd');
            setOpendelete(true);


        }

        const onopenedit = (index) => {

            navigate("/homedetails/" + index.Id);


            // alert(index.id)

            // setErrorname(false);
            // setHelpername('')
            // setErrorfamily(false);
            // setHelperfamily('')
            // setErrormelli(false);
            // setHelpermelli('')
            // setErrornumber(false);
            // setHelpernumber('')
            // setErrorcode(false);
            // setHelpercode('')
            // setErrorcredit(false);
            // setHelpercredit('')
            //
            //
            // setId(index.id);
            // setName(index.name);
            // setFamily(index.family);
            // setNationalid(index.nationalid);
            // setMobile(index.mobile);
            // setPersonnelcode(index.personnelcode)
            // setCredit(index.credit)
            // // alert(index.expireddate);
            // if (index.expireddate == null) {
            //     setExpireddate('')
            // } else {
            //     setExpireddate(index.expireddate)
            // }
            //
            // setOpenedit(true);
            //
            // if (index.active) {
            //     setSwitchhpossibility(true);
            // } else {
            //     setSwitchhpossibility(false);
            // }


        }


        const onsendexele = () => {


            if (files.length === 0) {
                Toast.fire({
                    icon: 'error',
                    title: 'لطفا فایل خود را انتخاب کنید'
                })
                return;
            }
            // console.log(files);


            setLoadersend(true)
            var bodyFormData0 = new FormData();
            bodyFormData0.append('File', files[0]);
            console.log(files);
            debugger;
            // bodyFormData2.append('Id', response.data.Id);
            // bodyFormData2.append('File', files[i]);

            uploadexele(bodyFormData0)
                .then((response) => {
                    setLoadersend(false)
                    setOpenexel(false);
                    Toast.fire({
                        icon: 'success',
                        title: response.data.errorDescription
                    })

                    if (response.data.numberfault > 0) {
                        Toast.fire({
                            icon: 'error',
                            title: 'تعداد ' + toPersianNum(response.data.numberfault) + ' عدد از کارمندان وارد نشد'
                        })

                    }
                    onRefreshpage();


                })
                .catch((error) => {
                    setLoadersend(false)
                    setOpenexel(false);
                });


        }


        const ontransactionemployee = () => {
            setOpenedit(false);
            setCreditadd('');
            setDescription('');
            setOpentransaction(true);
            ongettransaction(id)
        }

        const ontransactionemployeetable = (id0) => {
            setId(id0)
            setOpenedit(false);
            setCreditadd('');
            setDescription('');
            setOpentransaction(true);
            ongettransaction(id0)
        }

        const ongettransaction = (id) => {
            setLoader2(true);
            var bodyFormData2 = new FormData();
            bodyFormData2.append('Id', id);
            bodyFormData2.append('PageNumber', pagenumbert);
            bodyFormData2.append('PageSize', pagesizet);
            bodyFormData2.append('Q', qt);

            gettransaction(bodyFormData2)
                .then((response) => {


                    let pg = response.data.Count / pagesizet

                    console.log(pg);
                    if (pg < 1) {
                        setCountresponset(1)
                    } else {
                        setCountresponset(Math.floor(pg) + 1)
                    }


                    setTranactionList(response.data.list);
                    setCredit(response.data.credit)
                    setCredituser(response.data.usercredit)
                    // dispatch(savecredit(response.data.usercredit));

                    setLoader2(false);
                })
                .catch((error) => {

                });
        }

        const onClickyes = () => {
            // setLoaderdelete(true)
            setLoaderdeletedialog(true)
            var bodyFormData2 = new FormData();
            bodyFormData2.append('id', id);
            // alert(id)
            // bodyFormData2.append('Id', response.data.Id);
            // bodyFormData2.append('File', files[i]);

            deleteemployee(id)
                .then((response) => {
                    setOpendelete(false)
                    setLoaderdeletedialog(false)
                    setOpenedit(false);
                    Toast.fire({
                        icon: 'success',
                        title: response.data.errorDescription
                    })
                    onRefreshpage();


                })
                .catch((error) => {
                    setLoaderdeletedialog(false)
                    setOpendelete(false)
                    setOpenedit(false);
                });

        }

        const onClickcancel = () => {
            setOpendelete(false);

        };

        const handleChangePagination = (event, value) => {
            // alert(value);
            setLoader(true);
            // pagenumber = value
            setPagenumberMain(value)
            dispatch(savepagenumber(value))

            listhome(value, provincevalue, cityvalue, catidvalue, q, statusvalue, matchvalue, reviewvalue, reviewadminvalue,typeadminvalue)
                .then((response) => {
                    console.log(response.data.list);
                    setEmployeeList(response.data.list)
                    setLoader(false);
                })
                .catch((error) => {


                });


        };

        const handleChangePaginationt = (event, value) => {
            // alert(value);
            setLoader2(true);
            pagenumbert = value


            var bodyFormData2 = new FormData();
            bodyFormData2.append('Id', id);
            bodyFormData2.append('PageNumber', pagenumbert);
            bodyFormData2.append('PageSize', pagesizet);
            bodyFormData2.append('Q', qt);

            gettransaction(bodyFormData2)
                .then((response) => {

                    setTranactionList(response.data.list);
                    setCredit(response.data.credit)
                    setCredituser(response.data.usercredit)

                    setLoader2(false);
                })
                .catch((error) => {

                });


        };

        const onsearchbutton = (e) => {
            // alert('armin')
            setLoader(true);
            // // setValueq(e.target.value);
            //
            // ListEmployee(pagenumber, pagesize, valueq, typestatus, companyid)
            //     .then((response) => {
            //
            //
            //         let pg = response.data.Count / pagesize
            //
            //         if (pg < 1) {
            //             setCountresponse(1)
            //         } else {
            //             setCountresponse(Math.floor(pg) + 1)
            //         }
            //
            //
            //         setEmployeeList(response.data.list)
            //         setLoader(false);
            //
            //     })
            //     .catch((error) => {
            //
            //
            //     });
            setPagenumberMain(1)
            dispatch(savepagenumber(1))
            listhome(1, provincevalue, cityvalue, catidvalue, valueq, statusvalue, matchvalue, reviewvalue, reviewadminvalue,typeadminvalue)
                .then((response) => {

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );


                    setEmployeeList(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });

        }

        const onsearch = (e) => {


            // setLoader(true);
            setValueq(e.target.value);
            console.log(e.target.value);
            dispatch(saveQ(e.target.value))

            // ListEmployee(pagenumber, pagesize, e.target.value, typestatus, companyid)
            //     .then((response) => {
            //
            //
            //         let pg = response.data.Count / pagesize
            //
            //         if (pg < 1) {
            //             setCountresponse(1)
            //         } else {
            //             setCountresponse(Math.floor(pg) + 1)
            //         }
            //
            //
            //         setEmployeeList(response.data.list)
            //         setLoader(false);
            //
            //     })
            //     .catch((error) => {
            //
            //
            //     });


        }

        const onname = (e) => {
            setName(e.target.value);
            setErrorname(false);
            setHelpername('')
        };

        const onfamily = (e) => {
            setFamily(e.target.value);
            setErrorfamily(false);
            setHelperfamily('')
        };
        const onnationalid = (e) => {
            setNationalid(e.target.value);
            setErrormelli(false);
            setHelpermelli('')
        };
        const onmobile = (e) => {
            setMobile(e.target.value);
            setErrornumber(false);
            setHelpernumber('')
        };
        const onpersonalcode = (e) => {
            setPersonnelcode(e.target.value);
            setErrorcode(false);
            setHelpercode('')
        };
        const oncredit = (e) => {
            setCredit(e.target.value);
            setErrorcredit(false);
            setHelpercredit('')
        };

        const handleChangeSelectProvince = (event) => {
            onselectcity(event.target.value)
            setProvincevalue(event.target.value)
            setCityvalue(0)
            dispatch(saveprovince(event.target.value))
            dispatch(savecity(0))

            // if(event.target.value===0){
            //
            // }
            setPagenumberMain(1)
            dispatch(savepagenumber(1))
            setLoader(true);
            listhome(1, event.target.value, cityvalue, catidvalue, q, statusvalue, matchvalue, reviewvalue, reviewadminvalue,typeadminvalue)
                .then((response) => {

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );


                    setEmployeeList(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });

        }
        const handleChangeSelectCity = (event) => {
            setCityvalue(event.target.value)
            dispatch(savecity(event.target.value))
            setLoader(true);
            setPagenumberMain(1)
            dispatch(savepagenumber(1))
            listhome(1, provincevalue, event.target.value, catidvalue, q, statusvalue, matchvalue, reviewvalue, reviewadminvalue,typeadminvalue)
                .then((response) => {

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );


                    setEmployeeList(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });
        }

        const handleChangeSelectCat = (event) => {
            setCatidvalue(event.target.value)
            dispatch(savecatid(event.target.value))
            setLoader(true);
            setPagenumberMain(1)
            dispatch(savepagenumber(1))
            listhome(1, provincevalue, cityvalue, event.target.value, q, statusvalue, matchvalue, reviewvalue, reviewadminvalue,typeadminvalue)
                .then((response) => {

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );


                    setEmployeeList(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });
        }

        const handleChangeSelectMatchCount = (event) => {
            setMatchvalue(event.target.value)
            dispatch(savecountmatch(event.target.value))
            setLoader(true);
            setPagenumberMain(1)
            dispatch(savepagenumber(1))
            listhome(1, provincevalue, cityvalue, catidvalue, q, statusvalue, event.target.value, reviewvalue, reviewadminvalue,typeadminvalue)
                .then((response) => {

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );


                    setEmployeeList(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });
        }

        const handleChangeSelectReview = (event) => {
            setReviewvalue(event.target.value)
            dispatch(savereview(event.target.value))
            setLoader(true);
            setPagenumberMain(1)
            dispatch(savepagenumber(1))
            listhome(1, provincevalue, cityvalue, catidvalue, q, statusvalue, matchvalue, event.target.value, reviewadminvalue,typeadminvalue)
                .then((response) => {

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );


                    setEmployeeList(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });
        }

        const handleChangeSelectReviewAdmin = (event) => {
            setReviewadminvalue(event.target.value)
            dispatch(savereviewadmin(event.target.value))
            setLoader(true);
            setPagenumberMain(1)
            dispatch(savepagenumber(1))
            listhome(1, provincevalue, cityvalue, catidvalue, q, statusvalue, matchvalue, reviewvalue, event.target.value,typeadminvalue)
                .then((response) => {

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );


                    setEmployeeList(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });
        }

        const handleChangeSelectTypeAdmin = (event) => {
            setTypeadminvalue(event.target.value)
            dispatch(savetypeadmin(event.target.value))
            setLoader(true);
            setPagenumberMain(1)
            dispatch(savepagenumber(1))
            listhome(1, provincevalue, cityvalue, catidvalue, q, statusvalue, matchvalue, reviewvalue,reviewadminvalue, event.target.value)
                .then((response) => {

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );


                    setEmployeeList(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });
        }

        const handleChangeSelectStatus = (event) => {
            setStatusvalue(event.target.value)
            dispatch(savestatus(event.target.value))
            setLoader(true);
            setPagenumberMain(1)
            dispatch(savepagenumber(1))
            listhome(1, provincevalue, cityvalue, catidvalue, q, event.target.value, matchvalue, reviewvalue, reviewadminvalue,typeadminvalue)
                .then((response) => {

                    let pg = response.data.Count / pagesize
                    setCount(response.data.Count);

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }
                    // alert(Math.round(pg) );


                    setEmployeeList(response.data.list)

                    setLoader(false);
                    console.log("admin is" + admin);

                })
                .catch((error) => {
                });
        }

        const handleChangeSelect = (event) => {
            // setStatus(event.target.value);
            typestatus = event.target.value
            // alert(event.target.value);
            // onClickFilter();

            setLoader(true);
            // setValueq(e.target.value);

            ListEmployee(pagenumber, pagesize, q, event.target.value, companyid)
                .then((response) => {


                    let pg = response.data.Count / pagesize

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }


                    setEmployeeList(response.data.list)
                    setLoader(false);

                })
                .catch((error) => {


                });
        };

        const handleChangeSelectCompany = (event) => {
            setCompanyid(event.target.value);


            setLoader(true);
            // setValueq(e.target.value);

            ListEmployee(pagenumber, pagesize, q, status, event.target.value)
                .then((response) => {


                    let pg = response.data.Count / pagesize

                    if (pg < 1) {
                        setCountresponse(1)
                    } else {
                        setCountresponse(Math.floor(pg) + 1)
                    }


                    setEmployeeList(response.data.list)
                    setLoader(false);

                })
                .catch((error) => {


                });


            // alert(event.target.value)
        };

        const handleChangeSelectCompanynew = (event) => {
            setCompanyidnew(event.target.value);
        };


        return (


            <React.Fragment>

                <div style={{width: '100%', marginBottom: 20, display: 'flex', flexDirection: 'row-reverse'}}>
                    <AuthUserDropdown/>
                </div>


                <div style={{display: 'flex', flexDirection: 'row', marginBottom: 20, width: "100%"}}>
                    <div style={{width: "25%"}}>
                        <div style={{
                            width: "100%",
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: 'flex', justifyContent: 'start', alignItems: 'center',
                            flexDirection: 'row'
                        }}>
                            <div style={{
                                marginLeft: 10,
                                fontSize: 15,
                                fontFamily: 'Iran',
                                fontWeight: 'bold'
                            }}>
                                جستجو
                            </div>
                            <TextField
                                onChange={e => onsearch(e)}
                                autoComplete='off'
                                value={valueq} className='iran-font3'
                                placeholder="جستجو در نام اقامتگاه"
                                style={{marginRight: 5, width: '100%', color: '#000'}}
                                id="outlined-basic" variant="outlined" InputLabelProps={{
                                style: {height: 40, width: '100%', color: '#000', fontFamily: 'Iran'},
                                shrink: false,
                            }} InputProps={{
                                style: {
                                    height: 40,
                                    width: '100%',
                                    fontFamily: 'Iran', paddingLeft: 4,
                                    color: '#000'
                                }, endAdornment: <Button onClick={e => onsearchbutton(e)} variant="contained" style={{
                                    padding: 0,
                                    width: 120,
                                    fontSize: 14,
                                    height: 33, fontWeight: 500, borderRadius: 0,

                                    fontFamily: 'Iran'
                                }}
                                                         className="bg-primary text-white"
                                >جستجو</Button>
                            }}
                            />
                        </div>
                    </div>
                    <div style={{width: "25%"}}>
                        <div style={{
                            width: "100%",
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: 'flex', justifyContent: 'start', alignItems: 'center',
                            flexDirection: 'row'
                        }}>
                            <div style={{
                                marginLeft: 10,
                                fontSize: 15,
                                fontFamily: 'Iran',
                                fontWeight: 'bold',
                                width: 100
                            }}>
                                وضعیت :
                            </div>
                            <FormControl style={{width: 200}}>
                                {/*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*/}
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={statusvalue}
                                    style={{height: 40, fontFamily: 'Iran'}}
                                    label="وضعیت"
                                    onChange={handleChangeSelectStatus}
                                >
                                    <MenuItem style={{fontFamily: 'Iran'}} value={0}>همه</MenuItem>

                                    <MenuItem style={{fontFamily: 'Iran'}} value={6}>منتظر بررسی</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={7}>در حال بررسی</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={1}>تایید شده</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={2}>تایید نشده</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div style={{width: "25%"}}>
                        <div style={{
                            width: "100%",
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: 'flex', justifyContent: 'start', alignItems: 'center',
                            flexDirection: 'row'
                        }}>
                            <div style={{
                                marginLeft: 10,
                                fontSize: 15,
                                fontFamily: 'Iran',
                                fontWeight: 'bold',
                                width: 100
                            }}>
                                استان :
                            </div>
                            <FormControl style={{width: 200}}>
                                {/*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*/}
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={provincevalue}
                                    style={{height: 40, fontFamily: 'Iran'}}
                                    label="استان"
                                    onChange={handleChangeSelectProvince}
                                >


                                    {/*<MenuItem style={{fontFamily: 'Iran'}} value={0}>همه</MenuItem>*/}
                                    {
                                        provincelist.map((item, index) => (
                                            <MenuItem style={{fontFamily: 'Iran'}} value={item.id}>{item.name}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div style={{width: "25%"}}>
                        <div style={{
                            width: "100%",
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: 'flex', justifyContent: 'start', alignItems: 'center',
                            flexDirection: 'row'
                        }}>
                            <div style={{

                                fontSize: 15,
                                fontFamily: 'Iran',
                                fontWeight: 'bold',
                                width: 100
                            }}>
                                شهر :
                            </div>
                            <FormControl style={{width: 200}}>
                                {/*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*/}
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={cityvalue}
                                    style={{height: 40, fontFamily: 'Iran'}}
                                    label="شهر"
                                    onChange={handleChangeSelectCity}
                                >


                                    <MenuItem style={{fontFamily: 'Iran'}} value={0}>همه</MenuItem>
                                    {
                                        citylist.map((item, index) => (
                                            <MenuItem style={{fontFamily: 'Iran'}} value={item.id}>{item.name}</MenuItem>
                                        ))
                                    }

                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', marginTop: 10, marginBottom: 20, width: "100%"}}>
                    {/*<div style={{width: "25%"}}>*/}
                    {/*    <div style={{*/}
                    {/*        width: "100%",*/}
                    {/*        paddingLeft: 20,*/}
                    {/*        paddingRight: 20,*/}
                    {/*        display: 'flex', justifyContent: 'start', alignItems: 'center',*/}
                    {/*        flexDirection: 'row'*/}
                    {/*    }}>*/}
                    {/*        <div style={{*/}
                    {/*            marginLeft: 10,*/}
                    {/*            fontSize: 15,*/}
                    {/*            fontFamily: 'Iran',*/}
                    {/*            fontWeight: 'bold',*/}
                    {/*            width: 100*/}
                    {/*        }}>*/}
                    {/*            فیلترهای بیشتر :*/}
                    {/*        </div>*/}
                    {/*        <FormControl style={{width: 200}}>*/}
                    {/*            /!*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*!/*/}
                    {/*            <Select*/}
                    {/*                labelId="demo-simple-select-label"*/}
                    {/*                id="demo-simple-select"*/}
                    {/*                value={status}*/}
                    {/*                style={{height: 40, fontFamily: 'Iran'}}*/}
                    {/*                label="وضعیت"*/}
                    {/*                onChange={handleChangeSelect}*/}
                    {/*            >*/}


                    {/*                <MenuItem style={{fontFamily: 'Iran'}} value={0}>همه</MenuItem>*/}
                    {/*                <MenuItem style={{fontFamily: 'Iran'}} value={1}>فعال</MenuItem>*/}
                    {/*                <MenuItem style={{fontFamily: 'Iran'}} value={2}>غیر فعال</MenuItem>*/}
                    {/*            </Select>*/}
                    {/*        </FormControl>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div style={{width: "25%"}}>
                        <div style={{
                            width: "100%",
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: 'flex', justifyContent: 'start', alignItems: 'center',
                            flexDirection: 'row'
                        }}>
                            <div style={{
                                marginLeft: 10,
                                fontSize: 15,
                                fontFamily: 'Iran',
                                fontWeight: 'bold',
                                width: 100
                            }}>
                                مجموعه ها :
                            </div>
                            <FormControl style={{width: 200}}>
                                {/*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*/}
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={catidvalue}
                                    style={{height: 40, fontFamily: 'Iran'}}
                                    label="مجموعه ها"
                                    onChange={handleChangeSelectCat}
                                >


                                    <MenuItem style={{fontFamily: 'Iran'}} value={0}>همه</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={16}>خانه ویلایی</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={1036}>آپارتمان</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={17}>آپارتمان مبله</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={18}>سوییت</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={1035}>هتل آپارتمان</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={1037}>هتل</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={1033}>مسافرخانه</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={1032}>اقامتگاه بوم گردی</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={1038}>هاستل</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={1039}>کلبه</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>

                    <div style={{width: "25%"}}>
                        <div style={{
                            width: "100%",
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: 'flex', justifyContent: 'start', alignItems: 'center',
                            flexDirection: 'row'
                        }}>
                            <div style={{
                                marginLeft: 10,
                                fontSize: 15,
                                fontFamily: 'Iran',
                                fontWeight: 'bold',
                                width: 100
                            }}>
                                تطابق ها :
                            </div>
                            <FormControl style={{width: 200}}>
                                {/*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*/}
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={matchvalue}
                                    style={{height: 40, fontFamily: 'Iran'}}
                                    label="تطابق ها"
                                    onChange={handleChangeSelectMatchCount}
                                >


                                    <MenuItem style={{fontFamily: 'Iran'}} value={-1}>همه</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={0}>بدون تطابق</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={1}>۱ تطابق</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={2}>۲ تطابق</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={3}>۳ تطابق</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={4}>۴ تطابق</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={99}>حداقل ۱ تطابق</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>

                    <div style={{width: "25%"}}>
                        <div style={{
                            width: "100%",
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: 'flex', justifyContent: 'start', alignItems: 'center',
                            flexDirection: 'row'
                        }}>
                            <div style={{
                                marginLeft: 10,
                                fontSize: 15,
                                fontFamily: 'Iran',
                                fontWeight: 'bold',
                                width: 100
                            }}>
                                بررسی :
                            </div>
                            <FormControl style={{width: 200}}>
                                {/*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*/}
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={reviewvalue}
                                    style={{height: 40, fontFamily: 'Iran'}}
                                    label="بررسی"
                                    onChange={handleChangeSelectReview}
                                >


                                    <MenuItem style={{fontFamily: 'Iran'}} value={0}>همه</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={1}>بررسی شده</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={2}>بررسی نشده</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>

                    {isadmin&&
                    <div style={{width: "25%"}}>
                        <div style={{
                            width: "100%",
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: 'flex', justifyContent: 'start', alignItems: 'center',
                            flexDirection: 'row'
                        }}>
                            <div style={{
                                marginLeft: 0,
                                fontSize: 15,
                                fontFamily: 'Iran',
                                fontWeight: 'bold',
                                width: 100
                            }}>
                                اپراتورها :
                            </div>
                            <FormControl style={{width: 200}}>
                                {/*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*/}
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={reviewadminvalue}
                                    style={{height: 40, fontFamily: 'Iran'}}
                                    label="اپراتورها"
                                    onChange={handleChangeSelectReviewAdmin}
                                >


                                    <MenuItem style={{fontFamily: 'Iran'}} value={0}>همه</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={5}>روژین علیزاده</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={6}>محمدرضا واعظی</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={7}>مبینا خانجانی</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={9}>پانیذ قربانی</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={8}>مریم جعفری</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={10}>مریم باقر</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={11}>سورنا باغبان</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={12}>مهدی به نژاد</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    }
                </div>
                {isadmin&&
                <div style={{display: 'flex', flexDirection: 'row', marginTop: 10, marginBottom: 20, width: "100%"}}>
                   <div style={{width: "25%"}}>
                        <div style={{
                            width: "100%",
                            paddingLeft: 20,
                            paddingRight: 20,
                            display: 'flex', justifyContent: 'start', alignItems: 'center',
                            flexDirection: 'row'
                        }}>
                            <div style={{
                                marginLeft: 10,
                                fontSize: 15,
                                fontFamily: 'Iran',
                                fontWeight: 'bold',
                                width: 100
                            }}>
                                تاریخ :
                            </div>
                            <FormControl style={{width: 200}}>
                                {/*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*/}
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={typeadminvalue}
                                    style={{height: 40, fontFamily: 'Iran'}}
                                    label="تاریخ"
                                    onChange={handleChangeSelectTypeAdmin}
                                >


                                    <MenuItem style={{fontFamily: 'Iran'}} value={0}>همه</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={1}>امروز</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={2}>دیروز</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={3}>هفته قبلی</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={4}>هفته جاری</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={5}>ماه جاری</MenuItem>
                                    <MenuItem style={{fontFamily: 'Iran'}} value={6}>ماه قبلی</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                </div>
                }


                <JumboCardQuick
                    title={'لیست اقامتگاه ها ' + '(' + toPersianNum(count) + ')'}
                    // action={<div><Button className="iran-font3" variant="contained" style={{backgroundColor: '#2f53bd'}}
                    //                      onClick={opennewemployee}
                    //                      size={"small"} startIcon={<Add/>}><span className="iran-font3">کارمند جدید</span>
                    // </Button> <Button className="iran-font3" variant="contained" style={{backgroundColor: '#2f53bd'}}
                    //                   onClick={onopenexel}
                    //                   size={"small"}
                    //                   startIcon={<Add/>}><span className="iran-font3">اضافه کردن از exel</span>
                    // </Button></div>}
                    wrapperSx={{p: 3}}
                >

                    {/*<Typography className="iran-font" variant={'h2'} mb={3}>لیست کارمندان</Typography>*/}


                    <div style={{display: 'flex', flexDirection: 'column'}}>

                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'baseline'}}>

                            {/*<div style={{*/}
                            {/*    display: 'flex', justifyContent: 'center', width: 350,*/}
                            {/*    alignItems: 'center', marginRight: 15, marginLeft: 5, marginBottom: 20*/}
                            {/*}}>*/}
                            {/*    <TextField*/}
                            {/*        onChange={e => onsearch(e)}*/}
                            {/*        autoComplete='off'*/}
                            {/*        value={valueq} className='iran-font3'*/}
                            {/*        placeholder="جستجو در شماره ملی , اسم , کد پرسنلی"*/}
                            {/*        style={{marginRight: 5, width: '100%', color: '#000'}}*/}
                            {/*        id="outlined-basic" variant="outlined" InputLabelProps={{*/}
                            {/*        style: {height: 40, width: '100%', color: '#000', fontFamily: 'Iran'},*/}
                            {/*        shrink: false,*/}
                            {/*    }} InputProps={{*/}
                            {/*        style: {*/}
                            {/*            height: 40,*/}
                            {/*            width: '100%',*/}
                            {/*            fontFamily: 'Iran',*/}
                            {/*            paddingLeft: 4,*/}
                            {/*            color: '#000'*/}
                            {/*        }, endAdornment: <Button onClick={e => onsearchbutton(e)} variant="contained" style={{*/}
                            {/*            padding: 0,*/}
                            {/*            width: 120,*/}
                            {/*            fontSize: 14,*/}
                            {/*            height: 33, fontWeight: 500, borderRadius: 0,*/}

                            {/*            fontFamily: 'Iran'*/}
                            {/*        }}*/}
                            {/*                                 className="bg-primary text-white"*/}
                            {/*        >جستجو</Button>*/}
                            {/*    }}*/}
                            {/*    >*/}


                            {/*    </TextField>*/}
                            {/*</div>*/}


                            {/*<Grid style={{*/}
                            {/*    display: 'flex',*/}
                            {/*    flexDirection: 'row',*/}
                            {/*    alignItems: 'center',*/}
                            {/*    marginRight: 50,*/}
                            {/*    justifyContent: 'start',*/}
                            {/*    paddingRight: 0*/}
                            {/*}} item md={4} xs={12}>*/}
                            {/*    <div style={{*/}
                            {/*        marginLeft: 10,*/}
                            {/*        fontSize: 15,*/}
                            {/*        fontFamily: 'Iran',*/}
                            {/*        fontWeight: 'bold'*/}
                            {/*    }}>*/}
                            {/*        وضعیت عضویت*/}
                            {/*    </div>*/}


                            {/*    <FormControl style={{width: 160}}>*/}
                            {/*        /!*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*!/*/}
                            {/*        <Select*/}
                            {/*            labelId="demo-simple-select-label"*/}
                            {/*            id="demo-simple-select"*/}
                            {/*            value={status}*/}
                            {/*            style={{height: 40, fontFamily: 'Iran'}}*/}
                            {/*            label="وضعیت"*/}
                            {/*            onChange={handleChangeSelect}*/}
                            {/*        >*/}


                            {/*            <MenuItem style={{fontFamily: 'Iran'}} value={0}>همه</MenuItem>*/}
                            {/*            <MenuItem style={{fontFamily: 'Iran'}} value={1}>فعال</MenuItem>*/}
                            {/*            <MenuItem style={{fontFamily: 'Iran'}} value={2}>غیر فعال</MenuItem>*/}
                            {/*        </Select>*/}
                            {/*    </FormControl>*/}
                            {/*</Grid>*/}


                            {/*{admin ?*/}
                            {/*    <Grid style={{*/}
                            {/*        display: 'flex',*/}
                            {/*        flexDirection: 'row',*/}
                            {/*        alignItems: 'center',*/}
                            {/*        marginRight: 50,*/}
                            {/*        justifyContent: 'start',*/}
                            {/*        paddingRight: 0*/}
                            {/*    }} item md={4} xs={12}>*/}
                            {/*        <div style={{*/}
                            {/*            marginLeft: 10,*/}
                            {/*            fontSize: 15,*/}
                            {/*            fontFamily: 'Iran',*/}
                            {/*            fontWeight: 'bold'*/}
                            {/*        }}>*/}
                            {/*            سازمان مربوطه*/}
                            {/*        </div>*/}


                            {/*        <FormControl style={{width: 160}}>*/}
                            {/*            /!*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*!/*/}
                            {/*            <Select*/}
                            {/*                labelId="demo-simple-select-label"*/}
                            {/*                id="demo-simple-select"*/}
                            {/*                value={companyid}*/}
                            {/*                style={{height: 40, fontFamily: 'Iran'}}*/}
                            {/*                label="سازمان"*/}
                            {/*                onChange={handleChangeSelectCompany}*/}
                            {/*            >*/}

                            {/*                {Loadercompany ?*/}
                            {/*                    CompanyList.map((company, index) => (*/}
                            {/*                        <MenuItem style={{fontFamily: 'Iran'}}*/}
                            {/*                                  value={company.id}>{company.name}</MenuItem>*/}
                            {/*                    ))*/}
                            {/*                    :*/}
                            {/*                    null*/}
                            {/*                }*/}


                            {/*                /!*<MenuItem style={{fontFamily: 'Iran'}} value={0}>همه</MenuItem>*!/*/}
                            {/*                /!*<MenuItem style={{fontFamily: 'Iran'}} value={1}>فعال</MenuItem>*!/*/}
                            {/*                /!*<MenuItem style={{fontFamily: 'Iran'}} value={2}>غیر فعال</MenuItem>*!/*/}
                            {/*            </Select>*/}
                            {/*        </FormControl>*/}
                            {/*    </Grid>*/}

                            {/*    :*/}
                            {/*    null*/}
                            {/*}*/}


                        </div>

                        {/*<div style={{marginTop: 0, marginBottom: 5}}>armin</div>*/}

                        {Loader ?
                            <div style={{
                                display: 'flex', width: '100%', padding: 50,
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}>
                                <CircularProgress style={{color: '#2a44a1'}} size={24}/>
                            </div>
                            :
                            <div>
                                {adminshow ?
                                    <DataTablesEmployeeAdmin EmployeeList={EmployeeList} Loader={Loader}
                                                             onopenedit={onopenedit}
                                                             onopentransaction={ontransactionemployeetable}/>
                                    :
                                    <DataTablesEmployee EmployeeList={EmployeeList} Loader={Loader} onopenedit={onopenedit}
                                                        onopentransaction={ontransactionemployeetable}/>
                                }


                            </div>

                        }

                    </div>


                    <div style={{
                        width: '100%', marginTop: 15, marginBottom: 15,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Pagination page={pagenumbermain} onChange={handleChangePagination} count={countresponse}
                                    variant="outlined"
                                    color="primary"

                                    renderItem={(item) => (
                                        <PaginationItem
                                            slots={{previous: ArrowForwardIcon, next: ArrowBackIcon}}
                                            {...item}
                                        />
                                    )}


                        />

                    </div>


                </JumboCardQuick>


                <Dialog open={openadd} PaperProps={{
                    style: {margin: 0}
                }} onClose={onContactClose} className="slideInUpTiny">

                    <div style={{
                        display: 'flex', justifyContent: 'space-between',
                        alignItems: 'center', width: '100%'
                    }}>
                        <div style={{margin: 10, fontSize: 15, fontFamily: 'Iran'}}>
                            ثبت کارمند جدید
                        </div>

                        <IconButton onClick={onContactClose} aria-label="Close">
                            <Close/>
                        </IconButton>
                    </div>
                    <DialogContent>


                        <div style={{
                            display: 'flex', justifyContent: 'start', flex: 1,
                            alignItems: 'start', flexDirection: 'column', width: 270,
                        }}>

                            <TextField
                                inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                fullWidth
                                FormHelperTextProps={{
                                    style: {fontFamily: 'Iran'}
                                }}
                                style={{marginBottom: 10, fontFamily: 'Iran'}}
                                onChange={onname}
                                id="name" label="نام" helperText={helpername} error={errorname}
                                type="text" variant="outlined"
                            />
                            <TextField
                                inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                fullWidth
                                FormHelperTextProps={{
                                    style: {fontFamily: 'Iran'}
                                }}
                                style={{marginBottom: 10, fontFamily: 'Iran'}}
                                onChange={onfamily}
                                id="family" label="نام خانوادگی" helperText={helperfamily} error={errorfamily}
                                type="text" variant="outlined"
                            />
                            <TextField
                                inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                fullWidth
                                FormHelperTextProps={{
                                    style: {fontFamily: 'Iran'}
                                }}
                                style={{marginBottom: 10, fontFamily: 'Iran'}}
                                onChange={onnationalid}
                                id="nationalid" label="کدملی" helperText={helpermelli} error={errormelli}
                                type="number" variant="outlined"
                            />

                            <TextField
                                inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                fullWidth
                                FormHelperTextProps={{
                                    style: {fontFamily: 'Iran'}
                                }}
                                style={{marginBottom: 10, fontFamily: 'Iran'}}
                                onChange={onmobile}
                                id="mobile" label="شماره همراه" helperText={helpernumber} error={errornumber}
                                type="number" variant="outlined"
                            />

                            <TextField
                                inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                fullWidth
                                FormHelperTextProps={{
                                    style: {fontFamily: 'Iran'}
                                }}
                                style={{marginBottom: 10, fontFamily: 'Iran'}}
                                onChange={onpersonalcode}
                                id="nationalid" label="کد پرسنلی" helperText={helpercode} error={errorcode}
                                type="number" variant="outlined"
                            />


                            {admin ?

                                <div style={{width: '100%', marginBottom: 20}}>
                                    <div style={{
                                        marginLeft: 10, marginBottom: 10,
                                        fontSize: 15,
                                        fontFamily: 'Iran',
                                        fontWeight: 'bold'
                                    }}>
                                        سازمان
                                    </div>

                                    <FormControl style={{width: '100%'}}>
                                        {/*<InputLabel style={{ height: 40 }} id="demo-simple-select-label">دلیل</InputLabel>*/}
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={age}
                                            style={{fontFamily: 'Iran'}}
                                            label="سازمان" error={imp}
                                            onChange={handleChangeSelectCompanynew}
                                        >
                                            {/*<MenuItem style={{fontFamily: 'Iran'}} value={0}>انتخاب کنید</MenuItem>*/}


                                            {/*/!*{ReasonList.map((Name) => (*!/*/}
                                            {/*/!*    <MenuItem  value={1}>*!/*/}
                                            {/*/!*        {Name}*!/*/}
                                            {/*/!*    </MenuItem>*!/*/}
                                            {/*/!*))}*!/*/}


                                            {/*<MenuItem style={{fontFamily: 'Iran'}} value={1}>زیاد</MenuItem>*/}
                                            {/*<MenuItem style={{fontFamily: 'Iran'}} value={2}>متوسط</MenuItem>*/}
                                            {/*<MenuItem style={{fontFamily: 'Iran'}} value={3}>کم</MenuItem>*/}

                                            {Loadercompany ?
                                                CompanyList.map((company, index) => (
                                                    <MenuItem style={{fontFamily: 'Iran'}}
                                                              value={company.id}>{company.name}</MenuItem>
                                                ))
                                                :
                                                null
                                            }
                                        </Select>
                                        <FormHelperText>{helperimp}</FormHelperText>
                                    </FormControl>
                                </div>


                                :

                                null

                            }


                            <div style={{marginBottom: 10, fontFamily: 'Iran'}}>لطفا اعتبار اولیه را وارد کنید ( به تومان
                                )
                            </div>


                            <TextField
                                inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                fullWidth
                                FormHelperTextProps={{
                                    style: {fontFamily: 'Iran'}
                                }}
                                style={{marginBottom: 10, fontFamily: 'Iran'}}
                                onChange={oncredit} value={numberWithCommas(credit)}
                                id="nationalid" label="اعتبار" helperText={helpercredit} error={errorcredit}
                                variant="outlined"
                            />


                            {/*<TextField*/}
                            {/*    onChange={onmob1}*/}
                            {/*    style={{marginTop: 10}}*/}
                            {/*    fullWidth*/}
                            {/*    pattern="[0-9]*"*/}
                            {/*    id="name" label="شماره موبایل ۱"*/}
                            {/*    variant="outlined"*/}
                            {/*/>*/}
                            {/*<TextField*/}
                            {/*    onChange={onmob2}*/}
                            {/*    style={{marginTop: 10}}*/}
                            {/*    fullWidth*/}
                            {/*    pattern="[0-9]*"*/}
                            {/*    id="name" label="شماره موبایل ۲"*/}
                            {/*    variant="outlined"*/}
                            {/*/>*/}


                            <div className="d-flex align-items-center" style={{width: '100%'}}>


                                <Button variant="contained"
                                        color="primary"
                                        style={{
                                            width: '100%',
                                            height: 45,

                                            marginTop: 15,
                                            marginBottom: 15,
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid ',
                                        }} onClick={onsaveemployee}
                                        className="iran-font">

                                    {loaderbutton ?
                                        <CircularProgress style={{color: '#ffffff'}} size={24}/>
                                        :
                                        <div style={{
                                            fontSize: 17,
                                            fontFamily: 'Iran',
                                            fontWeight: 'bold',
                                            color: '#fff'
                                        }}>ثبت
                                        </div>
                                    }
                                </Button>


                            </div>


                        </div>


                    </DialogContent>
                </Dialog>


                <Dialog open={openedit} PaperProps={{
                    style: {margin: 0}
                }} onClose={onContactCloseEdit} className="slideInUpTiny">

                    <div style={{
                        display: 'flex', justifyContent: 'space-between',
                        alignItems: 'center', width: '100%'
                    }}>
                        <div style={{margin: 10, fontSize: 15, fontFamily: 'Iran'}}>
                            ویرایش کارمند
                        </div>

                        <IconButton onClick={onContactCloseEdit} aria-label="Close">
                            <Close/>
                        </IconButton>
                    </div>
                    <DialogContent>


                        <div style={{
                            display: 'flex', justifyContent: 'start', flex: 1,
                            alignItems: 'start', flexDirection: 'column', width: 270,
                        }}>

                            <TextField

                                fullWidth
                                inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                style={{marginBottom: 10, fontFamily: 'Iran'}}
                                onChange={onname}
                                FormHelperTextProps={{
                                    style: {fontFamily: 'Iran'}
                                }}
                                id="name" label="نام" value={name} helperText={helpername} error={errorname}
                                type="text" variant="outlined"
                            />
                            <TextField

                                inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                fullWidth className="iran-font3"
                                style={{marginBottom: 10, fontFamily: 'Iran'}}
                                onChange={onfamily}
                                FormHelperTextProps={{
                                    style: {fontFamily: 'Iran'}
                                }}
                                id="family" label="نام خانوادگی" value={family} helperText={helperfamily}
                                error={errorfamily}
                                type="text" variant="outlined"
                            />
                            <TextField
                                inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                fullWidth
                                style={{marginBottom: 10, fontFamily: 'Iran'}} value={nationalid}
                                onChange={onnationalid}
                                FormHelperTextProps={{
                                    style: {fontFamily: 'Iran'}
                                }}
                                id="nationalid" label="کدملی" helperText={helpermelli} error={errormelli}
                                type="number" variant="outlined"
                            />

                            <TextField
                                inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                fullWidth
                                style={{marginBottom: 10, fontFamily: 'Iran'}} value={mobile}
                                onChange={onmobile}
                                FormHelperTextProps={{
                                    style: {fontFamily: 'Iran'}
                                }}
                                id="mobile" label="شماره همراه" helperText={helpernumber} error={errornumber}
                                type="number" variant="outlined"
                            />


                            <TextField
                                inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                                InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                                fullWidth
                                style={{marginBottom: 10, fontFamily: 'Iran'}} value={personnelcode}
                                onChange={onpersonalcode}
                                FormHelperTextProps={{
                                    style: {fontFamily: 'Iran'}
                                }}
                                id="personnelcode" label="کد پرسنلی" helperText={helpercode} error={errorcode}
                                type="number" variant="outlined"
                            />


                            <div style={{
                                display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
                                alignItems: 'center', width: '100%'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginLeft: 20,
                                    fontFamily: 'Iran',
                                    fontWeight: 'bold',
                                }}>
                                    <div>وضعیت</div>

                                    <div>
                                        {switchhpossibility ?
                                            <div style={{marginRight: 5}}>- فعال</div>
                                            :
                                            <div style={{marginRight: 5}}>- غیرفعال</div>
                                        }


                                    </div>


                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    fontFamily: 'Iran',
                                    fontWeight: 'bold',
                                    alignItems: 'center',
                                }}>
                                    <Switch
                                        checked={switchhpossibility}
                                        onChange={handleChangeswitchpossibility}
                                        name="checkedA"
                                        inputProps={{'aria-label': 'secondary checkbox'}}
                                    />
                                </div>
                            </div>


                            {/*<div style={{marginBottom: 10}}>لطفا اعتبار اولیه را وارد کنید ( به تومان )</div>*/}


                            {/*<TextField*/}

                            {/*    fullWidth*/}
                            {/*    style={{marginBottom: 10}}*/}
                            {/*    onChange={(event) => setCredit(event.target.value)}*/}
                            {/*    id="credit" label="اعتبار" value={credit}*/}
                            {/*    type="number" variant="outlined"*/}
                            {/*/>*/}


                            {/*<TextField*/}
                            {/*    onChange={onmob1}*/}
                            {/*    style={{marginTop: 10}}*/}
                            {/*    fullWidth*/}
                            {/*    pattern="[0-9]*"*/}
                            {/*    id="name" label="شماره موبایل ۱"*/}
                            {/*    variant="outlined"*/}
                            {/*/>*/}
                            {/*<TextField*/}
                            {/*    onChange={onmob2}*/}
                            {/*    style={{marginTop: 10}}*/}
                            {/*    fullWidth*/}
                            {/*    pattern="[0-9]*"*/}
                            {/*    id="name" label="شماره موبایل ۲"*/}
                            {/*    variant="outlined"*/}
                            {/*/>*/}


                            <div className="d-flex align-items-center" style={{width: '100%'}}>


                                <Button variant="contained"
                                        style={{
                                            backgroundColor: '#2f53bd',
                                            width: '100%',
                                            height: 45,
                                            marginTop: 15,
                                            marginBottom: 15,
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid ',
                                        }} onClick={oneditemployee}
                                >

                                    {loaderbutton ?
                                        <CircularProgress style={{color: '#ffffff'}} size={24}/>
                                        :
                                        <div style={{
                                            fontSize: 17,
                                            fontFamily: 'Iran',
                                            fontWeight: 'bold',
                                            color: '#fff'
                                        }}>ویرایش
                                        </div>
                                    }
                                </Button>


                                <Button variant="contained"
                                        color="error"
                                        style={{
                                            width: '100%',
                                            height: 45,

                                            marginTop: 15,
                                            marginBottom: 15,
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid ',
                                        }} onClick={ondeleteemployee}
                                >

                                    {loaderdelete ?
                                        <CircularProgress style={{color: '#ffffff'}} size={24}/>
                                        :
                                        <div style={{
                                            fontSize: 17,
                                            fontFamily: 'Iran',
                                            fontWeight: 'bold',
                                            color: '#fff'
                                        }}>حذف
                                        </div>
                                    }
                                </Button>


                                <Button variant="contained"
                                        color="primary"
                                        style={{
                                            width: '100%',
                                            height: 45,

                                            marginTop: 15,
                                            marginBottom: 15,
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid ',
                                        }} onClick={ontransactionemployee}
                                        className="iran-font">

                                    {/*{loaderbutton ?*/}
                                    {/*    <CircularProgress style={{color: '#ffffff'}} size={24}/>*/}
                                    {/*    :*/}
                                    {/*    */}
                                    {/*}*/}

                                    <div style={{
                                        fontSize: 17,
                                        fontFamily: 'Iran',
                                        fontWeight: 'bold',
                                        color: '#fff'
                                    }}>افزایش اعتبار و تراکنش ها
                                    </div>


                                </Button>


                            </div>


                        </div>


                    </DialogContent>
                </Dialog>


                <Dialog open={openexel} PaperProps={{
                    style: {margin: 0}
                }} onClose={onContactCloseExel} className="slideInUpTiny">

                    <div style={{
                        display: 'flex', justifyContent: 'space-between',
                        alignItems: 'center', width: '100%'
                    }}>
                        <div style={{margin: 10, fontSize: 15, fontFamily: 'Iran'}}>
                            ارسال فایل
                        </div>

                        <IconButton onClick={onContactCloseExel} aria-label="Close">
                            <Close/>
                        </IconButton>
                    </div>
                    <DialogContent>


                        <div style={{
                            display: 'flex', justifyContent: 'start', flex: 1,
                            alignItems: 'start', flexDirection: 'column', width: 400,
                        }}>


                            <div style={{marginBottom: 10, fontFamily: 'Iran'}}>
                                لطفا فایل اکسل خود را بارگذاری کنید
                            </div>
                            <a href={sampleexel} style={{marginBottom: 10, fontFamily: 'Iran', fontWeight: 'Bold'}}>
                                دریافت فایل نمونه
                            </a>


                            <JumboCardQuick
                                wrapperSx={{pt: 0, backgroundColor: 'background.paper'}}>
                                <Div sx={{flex: 1}}>
                                    <DndWrapper>
                                        <div {...getRootProps()}>
                                            <input {...getInputProps()} />
                                            <Typography style={{fontFamily: 'Iran'}} variant={"body1"}>فایل را به اینجا
                                                بکشید یا برای انتخاب فایل کلیک
                                                کنید</Typography>
                                        </div>
                                    </DndWrapper>
                                    <Typography style={{fontFamily: 'Iran'}} variant={"h4"}>فایل ها</Typography>
                                    {files.length > 0 &&
                                    <List disablePadding sx={{display: 'flex'}}>
                                        <ListItem selected key={files.path} sx={{width: 'auto', mr: 1}}>
                                            {files[0].path} - {files[0].size} bytes
                                        </ListItem>
                                    </List>

                                    }


                                </Div>
                            </JumboCardQuick>


                            <div className="d-flex align-items-center" style={{width: '100%'}}>


                                <Button variant="contained"
                                        color="primary"
                                        style={{
                                            width: '100%',
                                            height: 45,

                                            marginTop: 15,
                                            marginBottom: 15,
                                            flex: 1,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            border: '1px solid ',
                                        }} onClick={onsendexele}
                                        className="iran-font">

                                    {loadersend ?
                                        <CircularProgress style={{color: '#ffffff'}} size={24}/>
                                        :
                                        <div style={{
                                            fontSize: 17,
                                            fontFamily: 'Iran',
                                            fontWeight: 'bold',
                                            color: '#fff'
                                        }}>ارسال فایل
                                        </div>
                                    }
                                </Button>


                            </div>


                        </div>


                    </DialogContent>
                </Dialog>


                <Dialog fullWidth={true}
                        maxWidth="xl" open={opentransaction} PaperProps={{
                    style: {margin: 0}
                }} onClose={onContactCloseTransaction} className="slideInUpTiny">

                    <div style={{
                        display: 'flex', justifyContent: 'space-between',
                        alignItems: 'center', width: '100%'
                    }}>
                        <div style={{margin: 10, fontSize: 17, fontWeight: 'bold', fontFamily: 'Iran'}}>
                            افزایش اعتبار {name} {family}
                        </div>

                        <IconButton onClick={onContactCloseTransaction} aria-label="Close">
                            <Close/>
                        </IconButton>
                    </div>
                    <DialogContent>


                        <div style={{
                            display: 'flex', justifyContent: 'start', flex: 1, marginTop: 5,
                            alignItems: 'start', flexDirection: 'column',
                        }}>


                            <div style={{display: 'flex', marginTop: 5, width: '100%', flexDirection: 'row'}}>
                                <Grid style={{width: '100%', marginLeft: 5}} container>
                                    <Grid style={{width: '100%'}} item lg={6}>
                                        {/*<JumboCardQuick style={{width: '100%', fontWeight: 'bold', fontFamily: 'Iran'}}*/}
                                        {/*                title={"مدیریت اعتبار"}*/}
                                        {/*>*/}

                                        {/*    /!*<div className="iran-font" style={{marginBottom: 10}}>*!/*/}
                                        {/*    /!*    میزان افزایش اعتبار خود را وارد کنید*!/*/}
                                        {/*    /!*</div>*!/*/}

                                        {/*    <TextField*/}
                                        {/*        value={description}*/}
                                        {/*        onChange={onDescription}*/}
                                        {/*        fullWidth label="توضیحات"*/}
                                        {/*        placeholder="توضیحات درباره تراکنش"*/}
                                        {/*        multiline*/}
                                        {/*        rows={2}*/}
                                        {/*        maxRows={4}*/}
                                        {/*    />*/}


                                        {/*    <div style={{display: 'flex', marginTop: 20, flexDirection: 'column',}}>*/}


                                        {/*        <Button variant="contained" onClick={onaddcredit}*/}
                                        {/*                style={{marginTop: 20}}*/}
                                        {/*        >*/}
                                        {/*            {loaderadd ?*/}
                                        {/*                <CircularProgress style={{color: '#ffffff'}} size={24}/>*/}
                                        {/*                :*/}
                                        {/*                <div style={{*/}
                                        {/*                    fontSize: 17,*/}
                                        {/*                    fontFamily: 'Iran',*/}
                                        {/*                    fontWeight: 'bold',*/}
                                        {/*                    color: '#fff'*/}
                                        {/*                }}>{value}*/}
                                        {/*                </div>*/}
                                        {/*            }*/}

                                        {/*        </Button>*/}


                                        {/*    </div>*/}


                                        {/*</JumboCardQuick>*/}


                                        <JumboCardQuick style={{width: '100%', height: '100%'}}
                                        >
                                            <div style={{display: 'flex', flexDirection: 'column'}}>

                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>


                                                    <RadioGroup style={{marginRight: 10, marginTop: 5}}
                                                                defaultValue={defaultValue}
                                                                name="customized-radios"
                                                                value={value} onChange={handleChange} row>
                                                        <FormControlLabel label={<div
                                                            style={{
                                                                fontFamily: 'Iran',
                                                                marginRight: 5,
                                                                marginLeft: 10,
                                                                fontSize: 15,
                                                                textAlign: 'center'
                                                            }}>
                                                            افزایش اعتبار
                                                        </div>} value="افزایش اعتبار" control={<StyledRadio/>}>
                                                        </FormControlLabel>
                                                        <FormControlLabel label={<div
                                                            style={{
                                                                fontFamily: 'Iran',
                                                                marginRight: 10,
                                                                fontSize: 15,
                                                                textAlign: 'center'
                                                            }}>
                                                            کاهش اعتبار
                                                        </div>} value="کاهش اعتبار" control={<StyledRadio/>}>
                                                        </FormControlLabel>
                                                    </RadioGroup>

                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        marginRight: 10,
                                                        alignItems: 'center'
                                                    }}>
                                                        <TextField
                                                            size={"small"}
                                                            label="اعتبار"
                                                            style={{height: 30}}
                                                            placeholder={"اعتبار"}
                                                            value={creditadd2}
                                                            margin={"dense"}
                                                            onChange={(e) => setCreditadd(e.target.value)}
                                                        />
                                                        <div style={{
                                                            marginRight: 10,
                                                            fontFamily: 'Iran',
                                                            fontSize: 15,
                                                            marginTop: 5
                                                        }}>تومان
                                                        </div>
                                                    </div>


                                                </div>


                                                <TextField
                                                    value={description}
                                                    onChange={onDescription}
                                                    style={{marginTop: 15}}
                                                    fullWidth label="توضیحات"
                                                    placeholder="توضیحات درباره تراکنش"
                                                    multiline
                                                    rows={2}
                                                    maxRows={4}
                                                />


                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'flex-end',
                                                    marginTop: 5,
                                                    flexDirection: 'column'
                                                }}>


                                                    <Button variant="contained" onClick={onaddcredit}
                                                            style={{marginTop: 5, width: '30%'}}
                                                    >
                                                        {loaderadd ?
                                                            <CircularProgress style={{color: '#ffffff'}} size={24}/>
                                                            :
                                                            <div style={{
                                                                fontSize: 17,
                                                                fontFamily: 'Iran',
                                                                fontWeight: 'bold',
                                                                color: '#fff'
                                                            }}>{value}
                                                            </div>
                                                        }

                                                    </Button>


                                                </div>


                                            </div>
                                        </JumboCardQuick>


                                    </Grid>

                                    <Grid style={{width: '100%', paddingRight: 10}} item lg={6}>
                                        <JumboCardQuick style={{width: '100%', height: '100%'}}
                                        >
                                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                                <div className="iran-font" style={{fontSize: 20, fontWeight: 'bold'}}>اعتبار
                                                    تخصیص داده شده
                                                    : {toPersianNum(Number(credituser).toLocaleString())} تومان
                                                </div>
                                                <div className="iran-font"
                                                     style={{fontSize: 20, fontWeight: 'bold', marginTop: 5}}>اعتبار کارمند
                                                    : {toPersianNum(Number(credit).toLocaleString())} تومان
                                                </div>
                                            </div>
                                        </JumboCardQuick>

                                    </Grid>
                                </Grid>
                                {/*<Grid style={{width: '100%'}} container>*/}
                                {/*    <Grid style={{width: '100%'}} item lg={12}>*/}
                                {/*        <JumboCardQuick style={{width: '100%'}}*/}
                                {/*                        title={"کاهش اعتبار"}*/}
                                {/*        >*/}
                                {/*            <div style={{marginBottom: 10}}>*/}
                                {/*                میزان کاهش اعتبار خود را وارد کنید*/}
                                {/*            </div>*/}

                                {/*            <div style={{width: '50%'}}>*/}
                                {/*                <TextField*/}
                                {/*                    size={"large"}*/}
                                {/*                    label="اعتبار"*/}
                                {/*                    placeholder={"اعتبار"}*/}
                                {/*                    value={amountneg}*/}
                                {/*                    margin={"dense"}*/}
                                {/*                    onChange={(e) => setAmountneg(e.target.value)}*/}
                                {/*                />*/}
                                {/*            </div>*/}


                                {/*            <Button variant="contained" onClick={opennewemployee} style={{width: 100}}*/}
                                {/*            >اعمال</Button>*/}

                                {/*        </JumboCardQuick>*/}
                                {/*    </Grid>*/}
                                {/*</Grid>*/}
                            </div>


                            <JumboCardQuick style={{width: '100%', marginTop: 10, fontFamily: 'Iran'}}
                                            title={"لیست تراکنش ها"} wrapperSx={{p: 3}}>

                                {Loader2 ?

                                    <div style={{
                                        display: 'flex', width: '100%', padding: 50,
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}>
                                        <CircularProgress style={{color: '#2a44a1'}} size={24}/>

                                    </div>

                                    :

                                    <DataTablesTransaction EmployeeList={TranactionList} Loader={Loader2}
                                                           onopenedit={onopenedit}/>
                                }


                                <div style={{
                                    width: '100%', marginTop: 15, marginBottom: 15,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <Pagination onChange={handleChangePaginationt} count={countresponset} variant="outlined"
                                                color="primary"

                                                renderItem={(item) => (
                                                    <PaginationItem
                                                        slots={{previous: ArrowForwardIcon, next: ArrowBackIcon}}
                                                        {...item}
                                                    />
                                                )}


                                    />

                                </div>


                            </JumboCardQuick>


                            {/*<div className="d-flex align-items-center" style={{width: '100%'}}>*/}


                            {/*    <Button variant="contained"*/}
                            {/*            color="primary"*/}
                            {/*            style={{*/}
                            {/*                width: '100%',*/}
                            {/*                height: 45,*/}

                            {/*                marginTop: 15,*/}
                            {/*                marginBottom: 15,*/}
                            {/*                flex: 1,*/}
                            {/*                display: 'flex',*/}
                            {/*                flexDirection: 'column',*/}
                            {/*                justifyContent: 'center',*/}
                            {/*                alignItems: 'center',*/}
                            {/*                border: '1px solid ',*/}
                            {/*            }} onClick={onsendexele}*/}
                            {/*            className="iran-font">*/}

                            {/*        {loadersend ?*/}
                            {/*            <CircularProgress style={{color: '#ffffff'}} size={24}/>*/}
                            {/*            :*/}
                            {/*            <div style={{*/}
                            {/*                fontSize: 17,*/}
                            {/*                fontFamily: 'iransans',*/}
                            {/*                fontWeight: 'bold',*/}
                            {/*                color: '#fff'*/}
                            {/*            }}>ارسال فایل*/}
                            {/*            </div>*/}
                            {/*        }*/}
                            {/*    </Button>*/}


                            {/*</div>*/}


                        </div>


                    </DialogContent>
                </Dialog>


                {opendelete ?

                    <DialogClose open={true} title='حذف کارمند' body='آیا از حذف این کارمند اطمینان دارید؟'
                                 loader={loaderdeletedialog}
                                 yes={onClickyes} cancel={onClickcancel}/>


                    :

                    <DialogClose open={false} title='حذف کارمند' body='آیا از حذف این کارمند اطمینان دارید؟'
                                 loader={loaderdeletedialog}
                                 yes={onClickyes} cancel={onClickcancel}/>

                }


            </React.Fragment>


        );
    }
;

export default DataTables;

